import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { PreferencesState, InterestsState } from './DataDefinitions';


const Preferences = ({ preferences, interests, onPreferencesChange, onInterestsChange }:
    {
        preferences: PreferencesState,
        interests: InterestsState,
        onPreferencesChange: (preferences: PreferencesState) => void;
        onInterestsChange: (interests: InterestsState) => void;
    }) => {

    const { t } = useTranslation();

    const handlePreferencesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = event.target;
        onPreferencesChange({ ...preferences, [name]: checked });
    };

    const handleInterestsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = event.target;
        onInterestsChange({ ...interests, [name]: checked });
    };

    return (
        <>
            <Row className="border-bottom border-dashed pb-3 mb-4">
                <Col xs={6}>
                    <div>
                        <h5 className="text-900 mb-3">{t("users.preferences.preferences")}</h5>
                        <div className="d-flex flex-column p-2 mb-2 ">

                            <Form.Check
                                type="checkbox"
                                id="career-coaching"
                                name="careerCoaching"
                                label="Career Coaching"
                                defaultChecked={preferences?.careerCoaching}
                                onChange={handlePreferencesChange}
                            />
                            <Form.Check
                                type="checkbox"
                                id="internal-mobility"
                                name="internalMobility"
                                label="Internal Mobility"
                                defaultChecked={preferences?.internalMobility}
                                onChange={handlePreferencesChange}
                            />
                            <Form.Check
                                type="checkbox"
                                id="leadership-coaching"
                                name="leadershipCoaching"
                                label="Leadership Coaching"
                                defaultChecked={preferences?.leadershipCoaching}
                                onChange={handlePreferencesChange}
                            />
                            <Form.Check
                                type="checkbox"
                                id="mentoring-leadership"
                                name="mentoringLeadership"
                                label="Mentoring for Leadership"
                                defaultChecked={preferences?.mentoringLeadership}
                                onChange={handlePreferencesChange}
                            />
                            <Form.Check
                                type="checkbox"
                                id="mentoring-new-position"
                                name="mentoringNewPosition"
                                label="Mentoring for New Position"
                                defaultChecked={preferences?.mentoringNewPosition}
                                onChange={handlePreferencesChange}
                            />
                            <Form.Check
                                type="checkbox"
                                id="mentoring-sales"
                                name="mentoringSales"
                                label="Mentoring for Sales"
                                defaultChecked={preferences?.mentoringSales}
                                onChange={handlePreferencesChange}
                            />
                            <Form.Check
                                type="checkbox"
                                id="shadow-mentoring"
                                name="shadowMentoring"
                                label="Shadow Mentoring"
                                onChange={handlePreferencesChange}
                            />
                            <Form.Check
                                type="checkbox"
                                id="team-coaching"
                                name="teamCoaching"
                                label="Team Coaching"
                                defaultChecked={preferences?.teamCoaching}
                                onChange={handlePreferencesChange}
                            />

                        </div>
                    </div>
                </Col>
                <Col xs={6}>
                    <div>
                        <h5 className="text-900 mb-3">{t("users.preferences.interests")}</h5>
                        <div className="d-flex flex-column p-2 mb-2 ">
                            <Form.Check
                                type="checkbox"
                                id="art"
                                name="art"
                                label="Art"
                                defaultChecked={interests?.art}
                                onChange={handleInterestsChange}
                            />
                            <Form.Check
                                type="checkbox"
                                id="cinema-theatre"
                                name="cinemaTheatre"
                                label="Cinema/Theatre"
                                defaultChecked={interests?.cinemaTheatre}
                                onChange={handleInterestsChange}
                            />
                            <Form.Check
                                type="checkbox"
                                id="creative-writing"
                                name="creativeWriting"
                                label="Creative Writing"
                                defaultChecked={interests?.creativeWriting}
                                onChange={handleInterestsChange}
                            />
                            <Form.Check
                                type="checkbox"
                                id="cooking"
                                name="cooking"
                                label="Cooking"
                                defaultChecked={interests?.cooking}
                                onChange={handleInterestsChange}
                            />
                            <Form.Check
                                type="checkbox"
                                id="reading"
                                name="reading"
                                label="Reading"
                                defaultChecked={interests?.reading}
                                onChange={handleInterestsChange}
                            />
                            <Form.Check
                                type="checkbox"
                                id="sport"
                                name="sport"
                                label="Sport"
                                defaultChecked={interests?.sport}
                                onChange={handleInterestsChange}
                            />
                            <Form.Check
                                type="checkbox"
                                id="technology"
                                name="technology"
                                label="Technology"
                                defaultChecked={interests?.technology}
                                onChange={handleInterestsChange}
                            />
                            <Form.Check
                                type="checkbox"
                                id="traveling"
                                name="traveling"
                                label="Traveling"
                                defaultChecked={interests?.traveling}
                                onChange={handleInterestsChange}
                            />
                            <Form.Check
                                type="checkbox"
                                id="yoga-meditation"
                                name="yogaMeditation"
                                label="Yoga/Meditation"
                                defaultChecked={interests?.yogaMeditation}
                                onChange={handleInterestsChange}
                            />
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default Preferences;
